import { createActionCreator } from "deox";

import { User } from "../../../types/types";

export const userSuccess = createActionCreator("userSuccess", (resolve) => (user: User) => resolve(user));

export const userLoading = createActionCreator("userLoading");

// Dispatched once the initial check for an already-signed-in session resolves with no usable user.
export const userCheckComplete = createActionCreator("userCheckComplete");
